import CompressorEffect from "./CompressorEffect";

export default CompressorEffect;
